export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', 'vc-quiz-en-za');
brandConfigMap.set('default', 'vc-quiz-en-za');
